import dayjs from '@/config/dayjs';

/**
 * True when a transaction date falls in the same calendar month as
 * `selectedMonth` (the ISO start-of-month key emitted by the cash flow bar
 * chart).
 */
export const isTransactionInMonth = (
  transactionDate: string,
  selectedMonth: string,
): boolean => dayjs(transactionDate).isSame(selectedMonth, 'month');
